import { selfSignUp, login } from '../../../api';
import { call, takeLatest, put, delay } from 'redux-saga/effects';
import {
  REQUEST_A_SELFSIGNUP_LINK,
  REQUEST_A_SELFSIGNUP_LINK_START,
  REQUEST_A_SELFSIGNUP_LINK_COMPLETE,
  REQUEST_A_SELFSIGNUP_LINK_ERROR,
  RESEND_EMAIL_OTP,
  RESEND_EMAIL_OTP_START,
  RESEND_EMAIL_OTP_COMPLETE,
  RESEND_EMAIL_OTP_ERROR,
  VERIFY_SIGNUP_EMAIL_OTP,
  VERIFY_SIGNUP_EMAIL_OTP_START,
  VERIFY_SIGNUP_EMAIL_OTP_COMPLETE,
  VERIFY_SIGNUP_EMAIL_OTP_ERROR,
  SET_SELF_SIGNUP_PASSWORD,
  SET_SELF_SIGNUP_PASSWORD_START,
  SET_SELF_SIGNUP_PASSWORD_COMPLETE,
  SET_SELF_SIGNUP_PASSWORD_ERROR,
  CREATE_SELFSIGNUP_ACCOUNT,
  CREATE_SELFSIGNUP_ACCOUNT_START,
  CREATE_SELFSIGNUP_ACCOUNT_COMPLETE,
  CREATE_SELFSIGNUP_ACCOUNT_ERROR,
} from './actions';
import errorStrings from '../../../constants/errorStrings';
import {getUserProfile} from '../userProfile/saga';

export function* requestASelfSignupLink({ payload: { params, onSuccess } }) {
  try {
    yield put({
      type: REQUEST_A_SELFSIGNUP_LINK_START,
    });
    const { response, error } = yield call(selfSignUp.requestASelfSignupLink, {
      params,
    });

    if (!!response) {
      yield put({
        type: REQUEST_A_SELFSIGNUP_LINK_COMPLETE,
        payload: { data: response.token },
      });
      onSuccess?.();
    } else {
      yield put(
        onRequestASelfSignupLinkError({
          error: error?.data.message ? error?.data.message : errorStrings.commonError,
        }),
      );
    }
  } catch (error) {
    yield put(
      onRequestASelfSignupLinkError({
        error: errorStrings.commonError,
      }),
    );
  }
}

export function* resendEmailOtp({ payload: { params } }) {
  try {
    yield put({
      type: RESEND_EMAIL_OTP_START,
    });
    const { response, error } = yield call(selfSignUp.resendEmailOtp, {
      params,
    });

    if (!!response) {
      yield put({
        type: RESEND_EMAIL_OTP_COMPLETE,
        payload: { data: response.token },
      });
    } else {
      yield put(
        onResendEmailOtpError({
          error: error?.data.message ? error?.data.message : errorStrings.commonError,
        }),
      );
    }
  } catch (error) {
    yield put(
      onResendEmailOtpError({
        error: errorStrings.commonError,
      }),
    );
  }
}

export function* verifySignupEmailOtp({
  payload: { params, onSuccessOfOtpVerification },
}) {
  try {
    yield put({
      type: VERIFY_SIGNUP_EMAIL_OTP_START,
    });
    const { response, error } = yield call(selfSignUp.verifySignupEmailOtp, {
      params,
    });

    if (!!response) {
      yield put({
        type: VERIFY_SIGNUP_EMAIL_OTP_COMPLETE,
        payload: { data: response.token },
      });
      onSuccessOfOtpVerification();
    } else {
      yield put(
        onVerifySignupEmailOtpError({
          error: error?.data.message ? error?.data.message : errorStrings.commonError,
        }),
      );
    }
  } catch (error) {
    yield put(
      onVerifySignupEmailOtpError({
        error: errorStrings.commonError,
      }),
    );
  }
}

export function* setSelfSignPassword({ payload: { params, onSuccessOfCreatePassword } }) {
  try {
    yield put({
      type: SET_SELF_SIGNUP_PASSWORD_START,
    });
    const { response, error } = yield call(selfSignUp.setSelfSignPassword, {
      params,
    });

    if (!!response) {
      yield put({
        type: SET_SELF_SIGNUP_PASSWORD_COMPLETE,
        payload: { data: response.token },
      });
      onSuccessOfCreatePassword();
    } else {
      yield put(
        onSetSelfSignPasswordError({
          error: error?.data.message ? error?.data.message : errorStrings.commonError,
        }),
      );
    }
  } catch (error) {
    yield put(
      onSetSelfSignPasswordError({
        error: errorStrings.commonError,
      }),
    );
  }
}

export function* createSelfSignupAccount({
  payload: { params, successCallback },
}) {
  try {
    yield put({
      type: CREATE_SELFSIGNUP_ACCOUNT_START,
    });
    var { response, error } = yield call(selfSignUp.createSelfSignupAccount, {
      params,
    });

    if (!!response) {
      var { refresh: refresh_token } = response;
      var { success, error } = yield call(login.fetchAuthToken, {
        refresh_token,
      });
      yield delay(5000);
      if (success) {
        yield call(getUserProfile);
        yield put({
          type: CREATE_SELFSIGNUP_ACCOUNT_COMPLETE,
          payload: { data: response.token },
        });
        successCallback();
      } else {
        yield put(
          onCreateSelfSignupAccount({
            error: error?.data.message ? error?.data.message : errorStrings.commonError,
          }),
        );
      }
    } else {
      yield put(
        onCreateSelfSignupAccount({
          error: error?.data.message ? error?.data.message : errorStrings.commonError,
        }),
      );
    }
  } catch (error) {
    yield put(
      onCreateSelfSignupAccount({
        error: errorStrings.commonError,
      }),
    );
  }
}

const onRequestASelfSignupLinkError = (payload = {}) => ({
  type: REQUEST_A_SELFSIGNUP_LINK_ERROR,
  payload,
});

const onResendEmailOtpError = (payload = {}) => ({
  type: RESEND_EMAIL_OTP_ERROR,
  payload,
});

const onVerifySignupEmailOtpError = (payload = {}) => ({
  type: VERIFY_SIGNUP_EMAIL_OTP_ERROR,
  payload,
});

const onSetSelfSignPasswordError = (payload = {}) => ({
  type: SET_SELF_SIGNUP_PASSWORD_ERROR,
  payload,
});

const onCreateSelfSignupAccount = (payload = {}) => ({
  type: CREATE_SELFSIGNUP_ACCOUNT_ERROR,
  payload,
});

function* watchRequestASelfSignupLink() {
  yield takeLatest(REQUEST_A_SELFSIGNUP_LINK, requestASelfSignupLink);
}

function* watchResendEmailOtp() {
  yield takeLatest(RESEND_EMAIL_OTP, resendEmailOtp);
}

function* watchVerifySignupEmailOtp() {
  yield takeLatest(VERIFY_SIGNUP_EMAIL_OTP, verifySignupEmailOtp);
}

function* watchSetSelfSignPassword() {
  yield takeLatest(SET_SELF_SIGNUP_PASSWORD, setSelfSignPassword);
}

function* watchCreateSelfSignupAccount() {
  yield takeLatest(CREATE_SELFSIGNUP_ACCOUNT, createSelfSignupAccount);
}

export const sagas = [
  watchRequestASelfSignupLink,
  watchResendEmailOtp,
  watchVerifySignupEmailOtp,
  watchSetSelfSignPassword,
  watchCreateSelfSignupAccount,
];
